﻿<form [formGroup]="loginForm" *ngIf="!isGlobalUser" novalidate class="marlinFormGroup">
    <div class="form-title">
        <h1 [innerHTML]='"gblLoginToMyhillsong" | translate'></h1>
    </div>
    <marlin-input [label]="'gblEmail'" [type]="'email'" [errorMessage]="'gblEmailAddressRequiredErrorMsg'" formControlName="loginEmail"></marlin-input>
    <marlin-input-password [label]="'gblPassword'" [errorMessage]="'gblPasswordRequiredErrorMsg'" formControlName="password"></marlin-input-password>
    <div class="row ps-1">
        <div class="col d-flex justify-content-between">
            <div class="form-check remember-me">
                <input class="form-check-input align-items-center" type="checkbox" id="remember" formControlName="isRemember" />
                <label class="form-check-label" for="remember" [innerHTML]='"gblRememberMe" | translate'></label>
            </div>
            <a class="forgot-password" [routerLink]="['/forgot-password']" [innerHTML]='"gblForgotPassword" | translate'></a>
        </div>
    </div>
    <div class="mb-2">
        <button type="submit" id="btnLogin" (click)="onSubmit()" class="btn btn-primary w-100" [innerHTML]='"gblLogin" | translate'></button>
    </div>
    <div class="mb-2 terms-conditions text-center">
        <div [innerHTML]='"gblBySigningInYouAgree" | translate'></div>
        <a href="{{policiesUrl}}" (click)='resetUserData()' [innerHTML]="'gblTerms' | translate"></a> &
        <a href="{{policiesUrl}}" (click)='resetUserData()' [innerHTML]="'gblPrivacyPolicy' | translate"></a>
    </div>
    <div class="text-center no-account">
        <hr>
        <label class="form-label">
            <b [innerHTML]='"gblDontHaveAccountYet" | translate'></b>
        </label>
        <div class="mt-2">
            <button type="button" [routerLink]="['/register']" class="btn btn-outline-primary w-100" (click)='resetUserData()' [innerHTML]="'gblCreateAccount' | translate"></button>
        </div>
    </div>
</form>

<div *ngIf="isGlobalUser" class="marlinFormGroup">
    <div class="form-title">
        <h3 [innerHTML]="('gblHello' | translate) + '!'"></h3>
        <h4 [innerHTML]='"gblExistingGlobalUserMessage" | translate'></h4>
        <div class="mb-3 text-center">
            <button class="btn btn-primary w-100 button-inherit" (click)="resetUserData()" [routerLink]="['/support']" [queryParams]="{type:'GeneralEnquiries'}"
                [innerHTML]="'gblContactOurTeam' | translate"></button>
            <label class="label-separator mb-2" [innerHTML]='"gblOR" | translate'></label>
            <button class="btn btn-primary w-100 button-inherit" (click)="resetUserData()" href='https://hillsong.com' [innerHTML]="'gblTakeMetoMyhillsongUpcomingEvents' | translate"></button>
        </div>
        <div class="mb-3 text-center">
            <a [routerLink]="['/']" (click)="resetUserData(); isGlobalUser = false">
                <i class="far fa-home fa-2x"></i>
                <span [innerHTML]="'gblBackToLogin' | translate"></span>
            </a>
        </div>
    </div>
</div>